<ra-modal [title]="'shared.modalListClients.title' | translate" [size]="'large'" (close)="close.emit()">
    @if (loading()) {
        <div class="container-loading">
            <ra-loading [message]="'shared.modalListClients.loading' | translate"/>
        </div>
    }
    @else {
        <!-- Message -->
        <p class="ra-label-s content-secondary description-message">{{ message() || ('shared.modalListClients.hint' | translate) }}</p>

        <!-- Input search -->
        <div class="container-input-search">
            <ra-input 
                [placeholder]="'shared.modalListClients.searchPlaceholder' | translate" 
                [formControl]="searchControl" 
                [showRequiredOrOptional]="false"
            />
        </div>

        @if (clientsFiltered().length === 0) {
            <div class="container-empty">
                <ra-empty [message]="'shared.modalListClients.emptyMessage' | translate"/>
            </div>
        }
        @else {
            <!-- List -->
            <div class="container-clients-list">
                @for (client of clientsFiltered(); track client._id) {
                    <ra-fillet
                        [icon]="'profile-2user'"
                        [title]="client.name"
                        [clickMessage]="'shared.modalListClients.clickSelect' | translate"
                        [description]="(client.address | addressFormat) || ('common.addressNotFound' | translate)"
                        (click)="selectClient.emit(client)"
                    />
                }
            </div>
        }
    }
</ra-modal>
